import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PillOption } from './pill-selector.model';

@Component({
    selector: 'dgx-pill-selector',
    templateUrl: './pill-selector.component.html',
    styleUrls: ['./pill-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PillSelectorComponent {
  @Input() public options: PillOption[];
  @Input() public selectedId: string;

  @Output() public select: EventEmitter<PillOption> = new EventEmitter();

  public clickHandler(option: PillOption): void {
    this.select.emit(option);
  }

  public getOptionId(index: number, option: PillOption): string {
    return option.id;
  }
}
